"use client";

import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
const sessions = [{
  id: "sess-1",
  topic: "AI-Driven Operations Strategy Review",
  date: "November 14, 2024 - 10:00 AM EST",
  status: "UPCOMING"
}, {
  id: "sess-2",
  topic: "Process Optimization & Efficiency Audit",
  date: "November 16, 2024 - 2:00 PM EST",
  status: "PENDING"
}, {
  id: "sess-3",
  topic: "Agentic Solutions Integration Workshop",
  date: "November 18, 2024 - 11:30 AM EST",
  status: "UPCOMING"
}, {
  id: "sess-4",
  topic: "Global 500 Legacy Transformation Case Study",
  date: "November 05, 2024 - 9:00 AM EST",
  status: "COMPLETED"
}, {
  id: "sess-5",
  topic: "SME Digital Readiness Assessment",
  date: "November 22, 2024 - 4:00 PM EST",
  status: "PENDING"
}];
export default function UpcomingMentorshipSessions() {
  return;
}